<template>
  <div id="index">
    <Headers></Headers>
    <router-view></router-view>
    <Footers></Footers>

    <div class="to-top" @click="backTop"><img src="../assets/images/back_to_top.png" alt=""></div>
  </div>
</template>
<script type="text/javascript">


  import Headers from '@/components/Header'
  import Footers from '@/components/Footer'

  export default {
    name: 'index',
    components: {
      Headers,
      Footers
    },
    data() {
      return {}
    },
    beforeMount() {
      let fullPath = this.$route.fullPath;
      if(fullPath.includes('#')){
        if(fullPath.includes('home')){
          window.location.href = `http://${window.location.host}`;
          return;
        }
        window.location.href = `http://${window.location.host}${fullPath.substr(fullPath.indexOf('#')+1)}`;
      }

    },
    methods: {
      backTop() {
        window.scrollTo(0, 0)
      },
    }
  }
</script>

<style scoped lang="less">
  #index{
    min-width: 1200px;
  }
  .to-top {
    position: fixed;
    right: 50px;
    bottom: 100px;
    width: 60px;
    height: 60px;
    background: rgba(0, 0, 0, .4);
    line-height: 60px;
    text-align: center;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// Index.vue?57b36a10